//Please add the language resource
const carrier = {
  carrierNo:'CarrierNo',
  carrierShortName:'CarrierShortName',
  carrierName: 'CarrierName',
  carrierTypeCode: 'CarrierTypeCode',
  carrierTypeName:'CarrierTypeName',
  contact:'Contact',
  tel:'Tel',
  email: 'Email',
  createTime:'CreateTime',
  creator:'Creator',
  updateTime:'UpdateTime',
  updater:'Updater',
  msg:{
  }
};
export default carrier



// WEBPACK FOOTER //
// ./src/page/md/carrier/lang/carrier.en.js